module.exports = __webpack_public_path__ + "img/keys.1d4d8ac.svg";